import React, { Component } from 'react'
import { Toast, List, Flex} from 'antd-mobile'
import { ORG_CODE, FARM_ORG } from '../../cache'
import LinkText from './components/link'
import df from 'dateformat'
import './index.css'
// import data from './data'
import Table from '../../components/Table';
import MateGroup from './components/mate-group';
import send from "../../utils/send";
import EmptyReport from "../../components/EmptyReport";
let birthWeekSource = [];
class Report05 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStart: false,
      showEnd: false,
      startDate: new Date(),
      endDate: new Date(),
      birthWeekSource,
      startWeek: '1905',
      endWeek: '2008',
      columns: [
        {
          'id': 'mate_group',
          'title': '配种组',
          'width': 70,
          'align': 'left',
          'fixed': true
        },
        {
          'id': 'mate_date',
          'title': '配种组期间',
          'width': 120
        },
        {
          'id': 'mate_number',
          'title': '配种数量',
          'width': 80
        },
        {
          'id': 'count_abort_type3',
          'title': '返情数量',
          'width': 80
        },
        {
          'id': 'count_abort_type2',
          'title': '空怀数量怀孕检查',
          'width': 130
        },
        {
          'id': 'count_abort_type1',
          'title': '流产数量',
          'width': 80
        },
        // {
        //   'id': 'column_avg_03',
        //   'title': 'Found Open', // todo 这个字段没有返回值。
        //   'width': 80
        // },
        {
          'id': 'count_dead_type',
          'title': '死亡数量',
          'width': 80
        },
        {
          'id': 'count_cull_type',
          'title': '其它淘汰数量',
          'width': 100
        },
        {
          'id': 'non_farrow_number',
          'title': '未怀孕',
          'width': 80
        },
        {
          'id': 'mate_farrow_number',
          'title': '配准数怀孕的',
          'width': 100
        },
        {
          'id': 'mate_farrow_rate',
          'title': '配准率怀孕的',
          'width': 100,
          render: (data) => {
            return <div style={{width: 100}}>{data.mate_farrow_rate}%</div>
          }
        },
        {
          'id': 'farrow_date',
          'title': '预产期',
          'width': 120
        }
      ],
      tableData: []
    }
  }
  async componentDidMount() {
    let birthWeek = await send({
      url: '/api/forward/ifarm/getWeekYearly',
      method: 'GET'
    });
    birthWeekSource = birthWeek.data;
    this.setState({
      startDate: birthWeekSource[2].weekStartDate,
      startWeek: birthWeekSource[2].mateGroup,
      endDate: birthWeekSource[0].weekEndDate,
      endWeek: birthWeekSource[0].mateGroup
    }, () => {
      this.doSearch()
    })
  }

  onCancel = () => {
    this.setState({
      showStart: false,
      showEnd: false
    })
  };
  doSearch = () => {
    const {startDate, endDate,startWeek,endWeek} = this.state;
    let start = startDate;
    let end = endDate;
    if (startDate > endDate) {
      start = endDate;
      end = startDate;
      this.setState({
        startDate: start,
        startWeek: endWeek,
        endWeek: startWeek,
        endDate: end})
    }
    Toast.loading('请稍候', 0);
    console.log('doSearch ', startDate, endDate,startWeek,endWeek);
    send({
      url: '/api/forward/ifarm/report5',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        startDate: start,
        endDate: end,
        language: 'zh_cn'
      }
    }).then(res => {
      Toast.hide();
      let tableData = res.data;
      const flag = tableData instanceof Array;
      if (!flag || res.status !== 200) {
        Toast.hide();
        return;
      }
      if (tableData.length === 0) {
        this.setState({tableData: []});
        return;
      }
      let attrs = Object.keys(tableData[0]);
      tableData.forEach(o => {
        attrs.forEach(a => {
          if (o[a] === null) {
            o[a] = ''
          }
        })
      });
      this.setState({tableData})
    })

  };
  render() {
    const {showStart, showEnd, startDate,endDate, startWeek, endWeek} = this.state;
    return (
      <React.Fragment>
        <div className="oneH">
          <List>
            <Flex className={showStart || showEnd? 'single-multi-menu-active' : ''}>
              <Flex.Item className={'single-multi-top-nav-bar'}>
                <List.Item onClick={() => {
                  this.setState({
                    showStart: !showStart,
                    showEnd: false
                  })}
                }
                >
                  <LinkText show={showStart}>配种组开始日期</LinkText>
                </List.Item>
              </Flex.Item>
              <Flex.Item className={'single-multi-top-nav-bar'}>
                <List.Item onClick={() => {
                  this.setState({
                    showStart: false,
                    showEnd: !showEnd
                  })}
                }
                >
                  <LinkText show={showEnd}>配种组截止日期</LinkText>
                </List.Item>
              </Flex.Item>
            </Flex>
          </List>
          {
            showStart ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <MateGroup data={birthWeekSource}
                         onCancel={() => {
                           this.setState({
                             showStart: false
                           })}
                         }
                         onConfirm={(value, data) => {
                           this.setState({
                             startWeek: value,
                             startDate: data.weekStartDate,
                             showStart: false
                           }, () => {
                             this.doSearch()
                           })
                         }}
                         value={startWeek}
              />
            </div>: null
          }

          {
            showEnd ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <MateGroup data={birthWeekSource}
                         onCancel={() => {
                           this.setState({
                             showEnd: false
                           })}
                         }
                         onConfirm={(value, data) => {
                           this.setState({
                             endWeek: value,
                             endDate: data.weekEndDate,
                             showEnd: false
                           }, () => {
                             this.doSearch()
                           })
                         }}
                         value={endWeek}
              />
            </div>: null
          }
          <List.Item
            className="span-4"
            disabled
            extra={df(startDate, 'yyyy-mm-dd') + ' ~ ' + df(endDate, 'yyyy-mm-dd')}
          >
            时间范围
          </List.Item>
          {
            showStart || showEnd ? <div className="menu-mask"/> : null
          }

          {this.state.tableData.length > 0 ?
            <Table columns={this.state.columns}
                   data={this.state.tableData}
                   stripe
            />
            : <EmptyReport height={250} />}
        </div>
      </React.Fragment>
    )
  }
}

export default Report05
